import { render } from "./Designations.vue?vue&type=template&id=52c15846&scoped=true"
import script from "./Designations.vue?vue&type=script&lang=js"
export * from "./Designations.vue?vue&type=script&lang=js"

import "./Designations.vue?vue&type=style&index=0&id=52c15846&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c15846"]])

export default __exports__